import React, { lazy, Suspense, useState } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  Colors
} from 'chart.js';
import Button from '../../library/Button/button';
import ReportSkeletonLoader from './ReportSkeletonLoader';
import { IGitReport } from '../../store/slice/gitReportSlice';
const RepositoryReport = lazy(async () => await import('./RepositoryReport'));
const OrganizationReport = lazy(async () => await import('./OrganizationReport'));
const UserReport = lazy(async () => await import('./UserReport'));

interface Props {
  report: IGitReport[];
}

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
ChartJS.register(ArcElement, Colors);

const ReportGraphs: React.FC<Props> = ({ report }) => {
  const FaAngleRightIcon = FaAngleRight as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
  const FaAngleLeftIcon = FaAngleLeft as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
  const [currentReport, setcurrentReport] = useState<number>(0);

  const nextReport = () => {
    setcurrentReport((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const previousReport = () => {
    setcurrentReport((prev) => (prev > 0 ? prev - 1 : 0));
  };

  if (report.length === 0) {
    return (
      <div className="sm:w-[780px] md:w-[1000px] xl:w-[1315px] h-screen flex flex-col items-center">
        <p className="text-xl mt-32">Data not available!!</p>
      </div>
    );
  }

  return (
    <div className="w-full h-fit rounded-md">
      <div className="w-full bg-offwhite bg-opacity-70 flex justify-between rounded-md p-4">
        <Button
          className="flex gap-1 justify-center items-center disabled:text-light-gray"
          onclick={previousReport}
          disabled={currentReport === 0}
        >
          <FaAngleLeftIcon />
          Previous
        </Button>
        <Button
          className="flex gap-1 justify-center items-center disabled:text-light-gray"
          onclick={nextReport}
          disabled={currentReport === 2}
        >
          Next
          <FaAngleRightIcon />
        </Button>
      </div>
      <Suspense fallback={<ReportSkeletonLoader />}>
        {currentReport === 0 && <RepositoryReport report={report} />}
        {currentReport === 1 && <OrganizationReport report={report} />}
        {currentReport === 2 && <UserReport report={report} />}
      </Suspense>
    </div>
  );
};

export default ReportGraphs;
